import { render, staticRenderFns } from "./SelectableText.vue?vue&type=template&id=30180ce4"
import script from "./SelectableText.vue?vue&type=script&lang=js"
export * from "./SelectableText.vue?vue&type=script&lang=js"
import style0 from "./SelectableText.vue?vue&type=style&index=0&id=30180ce4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports